export let baseUrl = process.env.REACT_APP_BASE_URL;
// export let baseUrl = "https://axproperty-api-new.onrender.com/api/";
// export let baseUrl = "https://axproperty-api-1.onrender.com/api/";

// export let baseUrl = "http://localhost:8000/api/";

// let baseUrl = "https://293b-2409-4085-879f-e246-818-2c67-2651-66a.ngrok-free.app/api/"

const Apis = {
  baseUrl,
  login: baseUrl + "auth/login",
  users: baseUrl + "user",
  hierarchyUsers: baseUrl + "team/getMyAllTeamMembers",
  leads: baseUrl + "lead",
  leadFollowUpNotification: baseUrl + "lead/notification",
  meeting: baseUrl + "meeting",
  team: baseUrl + "team",
  booking: baseUrl + "booking",
  bookingAdd: baseUrl + "booking/V2",
  developer: baseUrl + "developer",
  project: baseUrl + "project",
  getLeadById: baseUrl + "lead/getLeadById",
  meetingDetailsById: baseUrl + "meeting/meetingDetailsById",

  dashboardProfitAndLoss: baseUrl + "salary/pnl",
  dashboard: baseUrl + "dashboard",
  meetingDashboard: baseUrl + "dashboard/meetings",
  bookingDashboard: baseUrl + "dashboard/bookings",
  leadQualityDashboard: baseUrl + "dashboard/lead-quality",
  leadProjectWiseDashboard: baseUrl + "dashboard/lead-project-wise",
  closingLeadProjectWiseDashboard:
    baseUrl + "dashboard/closing-lead-project-wise",

  getBookingDetailsById: baseUrl + "booking/getBookingDetailsById",
  bookingPayment: baseUrl + "booking/updatePayment",
  getMeetingForBooking: baseUrl + "meeting/getMeetingForBooking",
  assignUsers: baseUrl + "user/assigningUsers",
  developerUpdateById: baseUrl + "developer/developerUpdateById",
  userUpdateById: baseUrl + "user/userUpdateById",
  leadUpdateById: baseUrl + "lead/leadUpdateById/",
  addNote: baseUrl + "lead/addNotes",
  statusUpdateById: baseUrl + "lead/statusUpdateById/",
  teamUpdatedById: baseUrl + "team/teamUpdateById/",
  leadAssignById: baseUrl + "lead/leadAssignById",
  assignedHistoryById: baseUrl + "lead/getAssignedHistory",
  statusHistoryById: baseUrl + "lead/getStatusHistory",
  updateMeetingById: baseUrl + "meeting/updateMeetingById/",
  deleteMeetingsById: baseUrl + "meeting/deleteMeetingsById",
  bookingApprovedById: baseUrl + "booking/bookingApprovedById",
  bookingRejectedById: baseUrl + "booking/bookingRejectedById",

  deleteLeadsByIds: baseUrl + "lead/deleteLeadsByIds",
  bulkStatusUpdateById: baseUrl + "lead/bulkStatusUpdateById",
  sendToLeadPool: baseUrl + "lead/sendToLeadPool",

  deleteBookingsById: baseUrl + "booking/deleteBookingsById",
  changePassword: baseUrl + "user/changePassword",
  setPassword: baseUrl + "user/setPassword",
  meetingReschedule: baseUrl + "meeting/reScheduleMeetingById",
  meetingConduct: baseUrl + "meeting/conductById",
  notificationSeenById: baseUrl + "user/notificationSeenById",
  getNotificationById: baseUrl + "user/getNotificationById",
  getCommissionData: baseUrl + "booking/getCommissionData",
  filterLeads: baseUrl + "lead/filterLeads",
  filterMeetings: baseUrl + "meeting/filterMeetings",
  filterBookings: baseUrl + "booking/filterBookings",
  meetingOtpVerify: baseUrl + "meeting/meetingOtpVerify",
  meetingOtpGenerate: baseUrl + "meeting/meetingOtpGenerate",
  caseFileUpload: baseUrl + "booking/caseFileUpload",
  meetingHistoryById: baseUrl + "meeting/getLatestMeetings",
  topPerformance: baseUrl + "booking/topPerformance",
  summaryOfEOI: baseUrl + "booking/summaryOfConfirmedBusinessBooking",
  topDeveloper: baseUrl + "booking/topDeveloper",
  leadPoolRestriction: baseUrl + "user/updatePoolRestriction",
  inactiveUser: baseUrl + "booking/reportOfInActiveEmployee",

  /* Event Management */
  eventsList: baseUrl + "event", // GET → list all events
  addEvent: baseUrl + "event", // POST → create new event
  getEventById: (id) => `${baseUrl}event/details/${id}`,
  updateEventById: (id) => `${baseUrl}event/${id}`, // PUT → update event
  cancelEventById: (id) => `${baseUrl}event/cancel/${id}`, // POST → cancel event
  deleteEventsByIds: `event/delete`, // POST → delete multiple events
  deleteEventsRegByIds: baseUrl + "eventRegister/delete",

  /* Hr Management */
  hrmsUser: baseUrl + "hrms/user",
  getTeamBySrManager: baseUrl + "hrms/user/getTeamsBySrManager",
  getAvailableRoles: baseUrl + "hrms/user/getAvailableRoles",
  hrmsLeave: baseUrl + "hrms/leave",
  getHrmsUserDetails: baseUrl + "hrms/user/getUserDetailsById",
  setAdvanceLeaves: baseUrl + "hrms/user/setAdvanceLeaves",
  getHrmsLeaveDetails: baseUrl + "hrms/leave/getDetailsById",
  sendInvitation: baseUrl + "hrms/user/sendInvitation",
  accessUpdate: baseUrl + "hrms/user/accessUpdate",
  updateUser: baseUrl + "hrms/user/updateUserById",
  hrmsLeaveDasbordData: baseUrl + "hrms/leave/dashboardData",
  hrmsLeaveApprove: baseUrl + "hrms/leave/leaveApproveById",
  hrmsLeaveReject: baseUrl + "hrms/leave/leaveRejectById",
  hrmsUserApprove: baseUrl + "hrms/user/approveById",
  hrmsUserDasbordData: baseUrl + "hrms/user/dashboardData",
  todaysMeetings: baseUrl + "meeting/getTodaysMeetings",
  getDeveloperOptions: baseUrl + "developer/getDeveloperOptions",
  remotePunch: baseUrl + "hrms/att/remotePunch",
  getAttendance: baseUrl + "hrms/att",
  hrmsRaiseIssues: baseUrl + "hrms/att/issueRaiseById",
  getAttDetails: baseUrl + "hrms/att/getDetailsById",
  attUpdateStatus: baseUrl + "hrms/att/updateStatusById",
  hrmsAttApprove: baseUrl + "hrms/att/approve-attendance",
  hrmsGetNotApprovedAtt: baseUrl + "hrms/att/get-notapproved-attendance",
  hrmsInterview: baseUrl + "recruitment",
  deleteInterviewByIds: baseUrl + "recruitment/delete-multiple-candidate",
  getHrmsInterviewDetails: baseUrl + "recruitment",
  statusChangeInterviewByIds: baseUrl + "recruitment/changestatus",
  hrmsRescheduleInterview: baseUrl + "recruitment/reschedule",
  hrmsPostInterviewProcess: baseUrl + "recruitment/post-intervierw-process",
  referralList: baseUrl + "refferal",
  referralListDetails: baseUrl + "refferal",
  referralDelete: baseUrl + "refferal/delete",
  referralAdd: baseUrl + "refferal",
  statusChangeReferralIds: baseUrl + "refferal/update_status",
  downloadInterview: baseUrl + "recruitment/download/excel",
  getShiftList: baseUrl + "shifts",
  addShift: baseUrl + "shifts/add",
  viewDepartment: (id) => `${baseUrl}shifts/${id}/departments`,
  assignShift: baseUrl + "shifts/assign",
  allDepartments: baseUrl + "departments",
  allUsers: (id) => `${baseUrl}shifts/${id}/users`,
  updateShift: baseUrl + "shifts",
  deleteShift: baseUrl + "shifts",
  getUsersOffDays: baseUrl + "offdays/users",
  getDepartmentsOffDays: baseUrl + "departments",
  addsetOffDays: baseUrl + "offdays/set",
  addGroup: baseUrl + "extra-allowances/groups/add",
  getListGroup: baseUrl + "extra-allowances/groups",
  updateGroup: baseUrl + "extra-allowances/groups",
  deleteGroup: baseUrl + "extra-allowances/groups",
  addAllowances: baseUrl + "extra-allowances/add",
  getViewAllowanceList: baseUrl + "extra-allowances",
  updateExtraAllowance: baseUrl + "extra-allowances",
  deleteExtraAllowance: baseUrl + "extra-allowances",

  // HRMS Settings
  getHrmsSettings: baseUrl + "hrms/hrms-settings",
  setApproveAttendanceSetting:
    baseUrl + "hrms/hrms-settings/set-approve-attendance",

  // Attendance Dashboard api
  hrmsDashboard: baseUrl + "hrms/dashboard",
  hrmsLeaveCancel: baseUrl + "hrms/leave/leaveCancelById",

  updateProject: baseUrl + "Project/updateProject",
  deleteProject: baseUrl + "project/deleteProjects",

  //expense cat api
  expanseList: baseUrl + "lead/get-all-category",
  expenseCatList: baseUrl + "lead/getExpenses",
  addExpenseCat: baseUrl + "lead/add-category",
  deleteExpenseCat: baseUrl + "lead/delete-category",
  expenseCatDetails: baseUrl + "lead/get-category",
  expenseCatUpdate: baseUrl + "lead/update-category",

  //expense list api
  addExpenseList: baseUrl + "lead/add-expense",
  deleteExpenseList: baseUrl + "lead/delete-expenses",
  expenseListDetails: baseUrl + "lead/get-expenses",
  updateExpense: baseUrl + "lead/update-expenses",

  //invoice list api
  invoiceList: baseUrl + "lead/getInvoices",
  invoiceDelete: baseUrl + "lead/deleteInvoice",
  invoiceDetails: baseUrl + "lead/getInvoiceById",
  invoiceCreate: baseUrl + "lead/add-invoice",
  invoiceBookingById: baseUrl + "lead/bookings",
  invoiceReceivedById: baseUrl + "lead/uploadReceivedStatus",
  invoiceUpdateById: baseUrl + "lead/updateInvoice",

  //expense team role wise list
  teamRoleExpense: baseUrl + "lead/getUserByRole",

  //lead pool api
  leadPool: baseUrl + "lead/leadPoolList",
  leadPoolClaim: baseUrl + "lead/claimLead",

  //Incentive
  incentive: baseUrl + "incentive/getIncentives",
  incentiveDetails: baseUrl + "incentive/details",
  incentivePayout: baseUrl + "incentive/payIncentive",
  // team Incentive
  teamIncentive: baseUrl + "teamIncentive/",

  // Confirmed Business
  confirmedBusiness: baseUrl + "booking/confirmedBusinessBooking",
  expressionInterest: baseUrl + "booking/executedBusinessBooking",

  //Lead Note edit and delete
  editNote: baseUrl + "notes",
  deleteNote: baseUrl + "notes",

  //HRMS User Devices delete
  deleteDevices: baseUrl + "hrms/user/update-devices",
  uploadFile: baseUrl + "media/upload",

  // HRMS payroll/holidays
  getHolidays: baseUrl + "holidays",
  addHolidays: baseUrl + "holidays/add",
  assignHolidays: baseUrl + "holidays/assign",
  getUsersHoliday: baseUrl + "holidays/users",
  getDepartmentsHoliday: baseUrl + "holidays/departments",
  getDepartments: baseUrl + "departments",

  permission: baseUrl + "permission",
  updatePermission: baseUrl + "permission/updatePermission",

  // HRMS payroll/salary-slips
  getSalarySlips: baseUrl + "salary",

  //Department
  addDepartment: baseUrl + "departments/add",
  departments: baseUrl + "departments",
  assignDepartments: baseUrl + "departments/assign",
  deassignDepartments: baseUrl + "departments/deassign",
  event: baseUrl + "event",
  eventRegister: baseUrl + "eventRegister",
};

export default Apis;
